import { render, staticRenderFns } from "./ProductInfoAdd.vue?vue&type=template&id=45bdc00c&scoped=true&"
import script from "./ProductInfoAdd.vue?vue&type=script&lang=js&"
export * from "./ProductInfoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bdc00c",
  null
  
)

export default component.exports